// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-business-attribute-StdLink-StdLink-module__link--fY_XW {
  color: black;
}
.src-business-attribute-StdLink-StdLink-module__link--fY_XW:hover {
  color: black;
}
.src-business-attribute-StdLink-StdLink-module__link--fY_XW.src-business-attribute-StdLink-StdLink-module__underline--jV2yE {
  text-decoration: underline;
}
/*# sourceMappingURL=StdLink.module.css.map */`, "",{"version":3,"sources":["webpack://./StdLink.module.less","webpack://./src/business/attribute/StdLink/StdLink.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;ACCF;ADAE;EACE,YAAA;ACEJ;ADAE;EACE,0BAAA;ACEJ;AACA,6CAA6C","sourcesContent":[".link {\n  color: black;\n  &:hover {\n    color: black;\n  }\n  &.underline {\n    text-decoration: underline;\n  }\n}\n",".link {\n  color: black;\n}\n.link:hover {\n  color: black;\n}\n.link.underline {\n  text-decoration: underline;\n}\n/*# sourceMappingURL=StdLink.module.css.map */"],"sourceRoot":""}]);
// Exports
export var link = `src-business-attribute-StdLink-StdLink-module__link--fY_XW`;
export var underline = `src-business-attribute-StdLink-StdLink-module__underline--jV2yE`;
export default ___CSS_LOADER_EXPORT___;
